// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__375lI","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2J39Q"};